import {
  Component,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';
import { ImageComponent } from '../../../atoms/image/image.component';

@Component({
  selector: 'app-portal-card',
  templateUrl: './portal-card.component.html',
  styleUrls: ['./portal-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImageComponent,
    ImmomioTooltipDirective,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe
  ]
})
export class PortalCardComponent implements OnInit {
  readonly identification = input<any>(undefined);
  readonly imgUrl = input<string>(undefined);
  readonly title = input<string>(undefined);
  readonly deselectDisabledText = input<string>(undefined);

  // behaviour control inputs
  readonly selectable = input(true);
  readonly deselectable = input(true);
  readonly disabled = input(false);
  readonly selected = input(false);

  readonly toggleEvent = output<any>();

  public checkControl = new FormControl({
    value: this.selected(),
    disabled: this.isDisabled
  });

  public ngOnInit() {
    /* eslint-disable @typescript-eslint/no-unsafe-call */
    this.checkControl.patchValue(this.selected());
    this.checkControl.valueChanges.subscribe(() =>
      this.toggleEvent.emit(this.identification())
    );
    /* eslint-enable @typescript-eslint/no-unsafe-call */
  }

  public get isSelected() {
    return !!this.checkControl?.value;
  }

  public get isDisabled() {
    return (
      this.disabled() ||
      (!this.isSelected && !this.selectable()) ||
      (this.isSelected && !this.deselectable())
    );
  }

  public get showDeselectionDisabledTooltip() {
    return (
      this.isSelected && !this.deselectable() && this.deselectDisabledText()
    );
  }
}
